// Vendor Libraries
import { ComponentFactoryResolver, Type } from '@angular/core';
// Utils
import { DoVariableBootstrap } from 'SecuritiesApp/ts/extendable-classes/do-variable-bootstrap';
// Modules
import { FormsModule } from '@angular/forms';
import { CommonModule, DOCUMENT } from '@angular/common';
import { BaseSecurityPageModule } from 'SecuritiesApp/ts/apps/base-security-page/app.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
// Components
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { HistoricalDataTableComponent } from 'SecuritiesApp/ts/features/historical-data-table/historical-data-table.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { SingleSeriesFundChartComponent } from 'ChartApp/ts/features/single-series-fund-chart/single-series-fund-chart.component';
import { DataTabAutocompleteComponent } from 'SecuritiesApp/ts/features/data-tab-autocomplete/data-tab-autocomplete.component';
import * as i0 from "@angular/core";
const entryComponents = [
    SideMenuComponent,
    TopBarNavComponent,
    HistoricalDataTableComponent,
    SecurityHeaderControlComponent,
    SingleSeriesFundChartComponent,
    DataTabAutocompleteComponent,
];
export class MutualFundsDataAppModule extends DoVariableBootstrap {
    constructor(_document, componentFactoryResolver) {
        super(_document, componentFactoryResolver, entryComponents);
        this.nonSingularComponents = [HistoricalDataTableComponent, SingleSeriesFundChartComponent];
    }
}
MutualFundsDataAppModule.ɵfac = function MutualFundsDataAppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsDataAppModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
MutualFundsDataAppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsDataAppModule });
MutualFundsDataAppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [FormsModule, CommonModule, IconModule, BaseSecurityPageModule] });
